module.exports = __webpack_public_path__ + "img/mu.475af446.svg";